import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, IconButton, Modal } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Close } from '@mui/icons-material';

import COLOR from "utils/constants/color";
import TeacherWhatsNewModal from 'modules/WhatsNew/teacherWhatsNewModal';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { IntroVideoPoster } from "utils/assets/images";
import { find, get } from "lodash";
import { handleCreateDontWhatsNew, handleListPopupWhatsNew } from 'store/whatsNew/thunks';
import { handleUpdateUserConfig } from 'store/users/thunks';
import { useCurrentUser } from 'store/users/selectors';
import { useFunVideos } from 'store/resources/selectors';
import { useWhatsNew } from 'store/whatsNew/selectors';
import Loading from './Loading';



//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------
//  -- Features -----------------------




//  -- Thunks -------------------------












//  -- Constants ----------------------

const useStyles = makeStyles((theme) => ({
    manageColor: {
        backgroundColor: '#cf26b8 !important',
        margin: '5px'
    },
    gradebookColor: {
        backgroundColor: '#ffb100 !important',
        margin: '5px'


    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        '& > *': {
            margin: '2px',
        },
    }
}));

const VideoContainer = styled.div`
    height: auto;
    flex: 1;
    justify-content: center;
`;
const TitleVideo = styled.span`
    color: ${COLOR.white};
    display: inline-block;
    font-size: 16px;
    flex: 1;
    font-weight: 300;
    justify-content: center;
    text-align: center;
    @media (min-width: 768px) {
        font-size: 24px;
    }
`;

const RowVideo = styled.div`
    flex: 1;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
    align-content: center;
    display:flex;
`;
const Video = styled.video`
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    height: auto;
    flex: 1;
    width: 50%;
    justify-content: center;
    @media only screen and (max-width: 600px){
        width: 95%;
    }
`;
const FunVideo = styled.video`
    border-radius: 8px;
    /* box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);*/
    // height: 70vh;
    flex: 1;
    width: auto;
    // width:100vw;
    padding:0px 20px;
    height:600px;

    @media only screen and (max-width: 1150px){
        width:100vw;
        height: 100%;
    }
`;
function isRunningOnIpad() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|Macintosh/.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
      return true;
    }
    if (/iPad/.test(userAgent)) {
      return true;
    }
  
    return false;
  }
  
export default function WelcomeVideo({ open, onClose, welcomeVideo = {} }) {
    const classes = useStyles();
    const currentUser = useCurrentUser();
    const [showWhatsNewOpen, setShowWhatsNewOpen] = useState(false);
    // const isReviewAccount = currentUser?.reviewAccount || false
    const fun_videos = useFunVideos(currentUser?.role);
    const [loader, setLoader] = useState(false);
    const [show_modal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const [isFunVideo, setFunVideo] = useState(false);
    const [videoConetent, setActiveVideo] = useState({});
    const [dontLoader, setDontLoader] = useState(false);
    const whatsNewData = useWhatsNew();

    useEffect(() => {
      const data = {
        user_id: currentUser?.id
      }
      dispatch(handleListPopupWhatsNew(data));
    }, []);

    const isIpad = isRunningOnIpad()
    const onDontShow = async () => {
        const todayDate = moment().format('YYYY-MM-DD')
        localStorage.setItem(`welcome_video_dont_show_${currentUser?.id}`, todayDate)
        sessionStorage.removeItem('welcome_video_shown_session')
        sessionStorage.setItem(`welcome_video_dont_show_session_${currentUser?.id}`, 'true')
        setLoader(true);
        setShowModal(false)
        onClose()
        // await dispatch(handleUpdateUserConfig(currentUser.id,{
        //     ...currentUser.config,
        //     last_video_shown:moment().toISOString(),
        //     welcome_video_show: false
        //  }));
        setLoader(false);
    }

    const onDontShowAgain = async (selected) => {
        const dontShowData = {
            id: selected?.id,
            user_id: currentUser?.id
        }
        setDontLoader(true);
        await dispatch(handleCreateDontWhatsNew(dontShowData))
        setDontLoader(false);
        setShowWhatsNewOpen(false);
    }

    const openWhatsNew = () => {
        const whats_new_shown = sessionStorage.getItem("whats_new_shown");
        if (whats_new_shown) return false;
        setShowWhatsNewOpen(true);
        sessionStorage.setItem("whats_new_shown",moment().toISOString());
        return true;
    }
  const shouldShowWelcomeVideo = (metadata, currentUser, isActive) => {
      // if (currentUser?.config?.welcome_video_show === false) {
      //   console.log('Welcome video disabled by user config');
      //     return false;
      // }
      if (isActive === false) {
        return false;
      }
      
      const dontShowDate = localStorage.getItem(`welcome_video_dont_show_${currentUser?.id}`)
      if (dontShowDate) {
        const today = moment().startOf('day')
        const dontShow = moment(dontShowDate).startOf('day')
        
        if (dontShow.isSame(today, 'day')) {
          return false
        }
      }
      
      const postponedDate = localStorage.getItem(`welcome_video_postponed_${currentUser?.id}`)
      if (postponedDate) {
        const today = moment().startOf('day')
        const postponed = moment(postponedDate).startOf('day')
        
        if (postponed.isSame(today, 'day')) {
          const postponedInSession = sessionStorage.getItem(`welcome_video_postponed_session_${currentUser?.id}`)
          
          
          if (postponedInSession) {
            return false
          } else {
          }
        }
      }
      
      const sessionVideoShown = sessionStorage.getItem('welcome_video_shown_session');
      if (sessionVideoShown) {
        return false;
      }
      
      if (metadata?.roleFilters) {
        const { teacher, student } = metadata.roleFilters;
        const userRole = currentUser?.role?.toLowerCase();
        
        if (teacher || student) {
          const isTeacher = userRole === 'teacher';
          const isStudent = userRole === 'student';
          
          if (isTeacher && !teacher) {
            return false;
          }
          
          if (isStudent && !student) {
            return false;
          }
        }
      } else {
        return true;
      }
      if (
        metadata?.startDate &&
        metadata?.endDate &&
        metadata?.selectedDays &&
        Array.isArray(metadata.selectedDays) &&
        metadata.selectedDays.length > 0
      ) {
        const currentDate = moment();
        const startDate = moment(metadata.startDate);
        const endDate = moment(metadata.endDate);
        const isWithinDateRange =
          currentDate.isSameOrAfter(startDate, 'day') && currentDate.isSameOrBefore(endDate, 'day');
        const currentWeekday = currentDate.format('dddd').toLowerCase();
        const isSelectedWeekday = metadata.selectedDays.includes(currentWeekday);
        return isWithinDateRange && isSelectedWeekday;
      }
      return true;
    };

   const handleFunVideo = async () => {
    const fun_video_shown = localStorage.getItem("fun_video_shown"+currentUser.id);
    const is_video_shown = fun_video_shown ? moment(fun_video_shown).isSame(moment(), "date") : false;
    const today_video = find(fun_videos, ["metadata.day_count", moment().get("day")])
    if (today_video && today_video.metadata.active && today_video.src && !is_video_shown) {
        if (currentUser && currentUser.config) {
            if (currentUser && currentUser.config.last_video_shown && moment(currentUser.config.last_video_shown).isBefore(moment(), "date")) {
                setFunVideo(true)
                setActiveVideo(today_video)
                setShowModal(true)
            } else if(currentUser && !currentUser.config.last_video_shown){
              setFunVideo(true)
              setActiveVideo(today_video)
              setShowModal(true)
            }
        } else {
            setFunVideo(true)
            setActiveVideo(today_video)
            setShowModal(true)
        }

        localStorage.setItem("fun_video_shown"+currentUser.id,moment().toISOString());
    }
   }
    useEffect(() => {
      if (open && !showWhatsNewOpen) {
          if (welcomeVideo && welcomeVideo.metadata) {
                if (welcomeVideo.metadata.active_mode === "fun_video") {
                  
                } else {
                    showWelcomeVideo() //disabled for now
                }
            } else {
                showWelcomeVideo()
            }

            const wasAlreadyShown = openWhatsNew();
            // openWhatsNew();
            if (!wasAlreadyShown || whatsNewData?.length === 0) {
              handleFunVideo();
            }
        }
    }, [welcomeVideo, fun_videos, open, whatsNewData])
  const showWelcomeVideo = () => {
        if (!welcomeVideo || Object.keys(welcomeVideo).length === 0) {
            return;
        }
        if (! welcomeVideo?.metadata) {
            welcomeVideo.metadata = {
                isActive: true,
                closable: true
            }
        } else { 
          welcomeVideo.metadata.closable = true
          if (welcomeVideo.metadata.isActive === undefined) {
            welcomeVideo.metadata.isActive = true
          }
        }
      if (shouldShowWelcomeVideo(welcomeVideo?.metadata, currentUser, welcomeVideo?.metadata?.isActive)) {
            // Set session flag to prevent showing again in this session
            sessionStorage.setItem('welcome_video_shown_session', 'true');    
            setFunVideo(false)
            setShowModal(true)
            setActiveVideo(welcomeVideo)
        }
    }
    const handleVideoEnd = async () => {
        const todayDate = moment().format('YYYY-MM-DD')
        localStorage.setItem(`welcome_video_postponed_${currentUser?.id}`, todayDate)
        sessionStorage.removeItem('welcome_video_shown_session')
        sessionStorage.setItem(`welcome_video_postponed_session_${currentUser?.id}`, 'true')
        setShowModal(false)
        onClose()
    }
    
    const onWatchLater = async () => {
        const todayDate = moment().format('YYYY-MM-DD')
        localStorage.setItem(`welcome_video_postponed_${currentUser?.id}`, todayDate)
        sessionStorage.removeItem('welcome_video_shown_session')
        sessionStorage.setItem(`welcome_video_postponed_session_${currentUser?.id}`, 'true')
        setShowModal(false)
        onClose()
    }
    const onCancel =() =>{
        const todayDate = moment().format('YYYY-MM-DD')
        localStorage.setItem(`welcome_video_postponed_${currentUser?.id}`, todayDate)
        sessionStorage.removeItem('welcome_video_shown_session')
        sessionStorage.setItem(`welcome_video_postponed_session_${currentUser?.id}`, 'true')
        setShowModal(false);
        onClose();
    }
    return (
      <>
        <Modal
          className={classes.modal}
          open={show_modal}
          onClose={onClose}
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        >
          <VideoContainer>
            {!isFunVideo && (
              <RowVideo>
                <TitleVideo>
                  {get(videoConetent, "displayName", "Welcome video")}
                </TitleVideo>
              </RowVideo>
            )}
            <RowVideo>
              <div style={{ position: "relative", width: "max-content" }}>
                <IconButton
                  onClick={onCancel}
                  style={{
                    // marginRight: 10,
                    position: "absolute",
                    // right:-7,
                    right: 7,
                    // top: -10,
                    top: -8,
                    backgroundColor: "red",
                    borderRadius: "50%",
                    color: "white",
                    cursor: "pointer",
                    zIndex: "10000",
                    padding: 12,
                    height: 30,
                    width: 30,
                  }}
                >
                  <Close />
                </IconButton>

                <FunVideo
                  autoPlay
                  controls={isIpad}
                  // controlsList="nodownload"
                  onError={handleVideoEnd}
                  poster={get(videoConetent, "poster", IntroVideoPoster)}
                  onEnded={handleVideoEnd}
                >
                  <source src={get(videoConetent, "src")} type="video/mp4" />
                </FunVideo>
              </div>
            </RowVideo>
            {get(videoConetent, "metadata.closable", false) && (
              <RowVideo>
                <div className={classes.root}>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={onWatchLater}
                  >
                    WATCH LATER
                  </Button>
                  <Button
                    disabled={loader}
                    variant="contained"
                    size="large"
                    color="secondary"
                    onClick={onDontShow}
                  >
                    {loader ? <Loading /> : null} DON'T SHOW AGAIN
                  </Button>
                </div>
              </RowVideo>
            )}
          </VideoContainer>
        </Modal>
        <TeacherWhatsNewModal
          open={showWhatsNewOpen}
          dontLoader={dontLoader}
          from="welcome_video"
          onClose={() => setShowWhatsNewOpen(false)}
          onDontShow={(val) => {
            onDontShowAgain(val);
          }}
        />
      </>
    );
}